module.exports = __webpack_public_path__ + "img/role03.642b2d5c.png";